// Import API service
import { tellersApi } from '@/services/api'

// Initial state
const state = {
  tellers: [],
  currentTeller: null,
  loading: false,
  error: null
}

// Getters
const getters = {
  allTellers: state => state.tellers,
  currentTeller: state => state.currentTeller,
  isLoading: state => state.loading,
  error: state => state.error
}

// Mutations
const mutations = {
  SET_TELLERS(state, tellers) {
    state.tellers = tellers
  },
  SET_CURRENT_TELLER(state, teller) {
    state.currentTeller = teller
  },
  SET_LOADING(state, status) {
    state.loading = status
  },
  SET_ERROR(state, error) {
    state.error = error
  }
}

// Actions
const actions = {
  async fetchTellers({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await tellersApi.getTellers()
      commit('SET_TELLERS', response.data)
      commit('SET_ERROR', null)
    } catch (error) {
      console.error('Error fetching tellers:', error)
      commit('SET_ERROR', 'Failed to load tellers')
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async fetchCurrentTeller({ commit }) {
    commit('SET_LOADING', true)
    try {
      const response = await tellersApi.getCurrentTeller()
      commit('SET_CURRENT_TELLER', response.data)
      commit('SET_ERROR', null)
    } catch (error) {
      if (error.response && error.response.status === 404) {
        // Not found is not an error, just means user is not a teller
        commit('SET_CURRENT_TELLER', null)
        commit('SET_ERROR', null)
      } else {
        console.error('Error fetching current teller:', error)
        commit('SET_ERROR', 'Failed to load teller information')
      }
    } finally {
      commit('SET_LOADING', false)
    }
  },
  
  async deleteTeller({ commit, dispatch }, id) {
    commit('SET_LOADING', true)
    try {
      await tellersApi.deleteTeller(id)
      await dispatch('fetchTellers') // Refresh the tellers list
      commit('SET_ERROR', null)
      return { success: true, message: 'Teller station deleted successfully' }
    } catch (error) {
      console.error('Error deleting teller:', error)
      commit('SET_ERROR', error.response?.data?.message || 'Failed to delete teller station')
      return { success: false, message: error.response?.data?.message || 'Failed to delete teller station' }
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
} 